import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import LABELESPECIAL from '../../../business-const/Label/LabelEspecial'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import { FieldArray } from 'formik'

import {
    formataValor
} from '../../../business-components/Formata/Formata'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem2sm3xs6,
    GridItem3sm4xs10,
    GridItem3xs12,
    GridItem4,
    GridItem5xs12,
    GridItem6,
    GridItem6xs11,
    GridItem6xs12,
    GridItem8xs12,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
    CardGridDividerElementos,
    CardGridEntradaDadosHeaderBody,
} from '../../../business-components/Card/Card'

import {
    ListRadioGroup,
} from '../../../business-components/RadioGroup/RadioGroup'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorValor,
    TextValidatorCelular,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    IconButtonExpandMoreLess,
} from '../../../business-components/IconButton/IconButton'

import {
    SimNaoRadioGroup
} from '../../../business-rules/RadioGroup/SimNaoRadioGroup'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import formTypeList from '../../../business-rules/List/formTypeList'

import {
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
    calculaIdadesDataSimulacao,
} from '../cliente-form/ClienteService'

import {
    calculaTotaisReceitaMensal,
} from '../garantias-form/GarantiasServiceReceitaMensal'

import {
    calculaTotaisDiaDia,
} from '../despesas-form/DespesasServiceDiaDia'

import {
    processaRegistrosDefaultIniciaisEducacao,
    calculaEducacaoFilhaoEnteadaoBaseOutraosFilhaosEnteadaos,
    calculaTotaisEducacao,
} from '../despesas-form/DespesasServiceEducacao'

import {
    calculaTotaisFinanciamento,
} from '../despesas-form/DespesasServiceFinanciamento'

import {
    calculaTotaisProjetoVidaSonho,
} from '../projetoVidaSonho-form/ProjetoVidaSonhoServiceProjetoVidaSonho'

import {
    calculaTotaisPatrimonioImobilizado,
} from '../garantias-form/GarantiasServicePatrimonioImobilizado'

import {
    calculaTotaisRecursosFinanceiros,
} from '../garantias-form/GarantiasServiceRecursosFinanceiros'

import {
    processaValoresDefaultIniciaisCenariosTaxas,
} from '../estudo-parametros/EstudoServiceCenariosTaxas'

import {
    processaValoresDefaultIniciaisClienteConjuge,
} from '../estudo-parametros/EstudoServiceClienteConjuge'

import {
    processaCenariosDefaultJsonUsuario,
    atualizarCenario,
} from '../estudo-parametros/EstudoServiceCenarios'

import {
    AposentadoriaExpectativaVidaCliente,
    AposentadoriaExpectativaVidaClienteConjuge,
} from '../simulacaoFinanceira-form/SimulacaoFinanceiraCompParametros'

import {
    calculaConfiguracaoPerguntas,
    processaRegistrosDefaultIniciaisPerguntas,
    processaAlteracaoPerguntasValor, 
} from './FormServicePerguntas'

import {
    Formulario
} from './FormCompPergunta'

import FormFormMultiList from './FormFormMultiList'

import FormFormDiaDia from './FormFormDiaDia'

import FormFormEducacao from './FormFormEducacao'

import FormFormFinanciamento from './FormFormFinanciamento'

import FormFormProjetoVidaSonho from './FormFormProjetoVidaSonho'

import FormFormPatrimonioImobilizado from './FormFormPatrimonioImobilizado'

import FormFormReceitaMensal from './FormFormReceitaMensal'

import FormFormRecursosFinanceiros from './FormFormRecursosFinanceiros'

import FormFormSolicitacaoArquivo from './FormFormSolicitacaoArquivo'



const AposentadoriaExpectativaVidaClienteAposentadoriaExpectativaVidaClienteConjuge = ({ values, handleChange, setFieldValue }) => {

    const [expandiu, setExpandiu] = useState(false)

    atualizarCenario(values)

    return (
        <GridContainer>
            <GridItem6xs11>
                {!expandiu && (
                    <AposentadoriaExpectativaVidaCliente
                        values={values}
                        setFieldValue={setFieldValue}
                    />
                )}
            </GridItem6xs11>

            <GridItem1>
                <AposentadoriaExpectativaVidaClienteConjuge
                    values={values}
                    handleChange={handleChange}
                    setExpandiu={setExpandiu}
                />
            </GridItem1>
        </GridContainer>
    )
}



const FormFormPerguntasAux = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, vars/*linhaTipoLicenca, jsonConfiguracao*/, linhaFormList, completo,
        jsonIntegracao, arquivoList, obterArquivoList, formularioList, setPrimInd, primInd,
            /*pdf, */grupoPerguntaAnt }) => {

    const [salvar, setSalvar] = useState(false)

    const salvarAutomaticamente = () => {

        setSalvar(true)
    }

    if (salvar) {

        setSalvar(false)

        handleSubmitAutomatico(values)
    }

    const integracaoInstitucionalCaptacaoLeads = !(!jsonIntegracao ||
            (!jsonIntegracao.integracaoInclusaoSiteInstitucional &&
            !jsonIntegracao.integracaoInclusaoSiteInstitucional2 &&
            !jsonIntegracao.integracaoInclusaoCaptacaoLeads))

    return (
        <>
            {!integracaoInstitucionalCaptacaoLeads && (
                <GridContainer>
                    <GridItem4
                        className='mt-2 p-3'
                    >
                        <Formulario
                            values={values}
                            handleChange={handleChange}
                            linhaFormList={linhaFormList}
                            completo={completo}
                            formularioList={formularioList}
                            setPrimInd={setPrimInd}
                        />
                    </GridItem4>
                </GridContainer>
            )}

            <FieldArray name="perguntas">
                {(arrayHelpers) => (
                    <DivForm
                        className='mt-2'
                    >
                        <DivForm>
                            {values.perguntas?.map((item, ind) => {

                                const linhaPerguntas =
                                    pesquisaList(linhaFormList.perguntasFormList, item.id)

                                const exibirGrupoPergunta =
                                    linhaPerguntas.grupoPergunta &&
                                    linhaPerguntas.grupoPergunta !== grupoPerguntaAnt
                                        ?
                                            true
                                        :
                                            false

                                grupoPerguntaAnt = linhaPerguntas.grupoPergunta

                                const linhaFormTypeList =
                                    pesquisaList(formTypeList, linhaPerguntas.type)

                                const GridItemDescricao =
                                    linhaPerguntas.GridItemDescricao ? linhaPerguntas.GridItemDescricao : GridItem6

                                const GridItemRadioList =
                                    linhaPerguntas.GridItemRadioList ? linhaPerguntas.GridItemRadioList : GridItem12

                                return (
                                            (
                                                !linhaPerguntas.perguntaCondicionadaSim ||
                                                (
                                                    linhaPerguntas.perguntaCondicionadaSim &&
                                                    pesquisaList(values.perguntas,
                                                        linhaPerguntas.perguntaCondicionadaSim).simNao === 'S'
                                                )
                                            ) &&
                                            (
                                                !linhaPerguntas.perguntaCondicionadaRadio ||
                                                (
                                                    linhaPerguntas.perguntaCondicionadaRadio &&
                                                    pesquisaList(linhaPerguntas.perguntaCondicionadaRadioList,
                                                        pesquisaList(values.perguntas,
                                                            linhaPerguntas.perguntaCondicionadaRadio).radio).id
                                                )
                                            ) &&
                                            (
                                                (completo && linhaPerguntas.completo) ||
                                                (!completo && !linhaPerguntas.completo)
                                            ) &&
                                            item.default &&
                                            (
                                                !jsonIntegracao ||
                                                !jsonIntegracao.tipoLinkCaptacaoLeads ||
                                                (
                                                    jsonIntegracao &&
                                                    jsonIntegracao.tipoLinkCaptacaoLeads ===
                                                        linhaPerguntas.tipoLinkCaptacaoLeads
                                                )
                                            )
                                    )
                                ? (
                                    <CardGridDivBodyEntradaDados
                                        key={ind}
                                    >
                                        {exibirGrupoPergunta
                                            ?
                                                <GridContainer>
                                                    <GridItem12
                                                        className='bg-default text-white font-bold text-18 mt-2 mb-2 p-3' //text-center 
                                                    >
                                                        {linhaPerguntas.grupoPergunta}
                                                    </GridItem12>
                                                </GridContainer>
                                            :
                                                ''
                                        }

                                        {(
                                            (ind !== primInd && !exibirGrupoPergunta) ||
                                            (
                                                (formularioList.length > 1 /*|| pdf*/) &&
                                                !grupoPerguntaAnt
                                            )
                                        ) && 
                                        (
                                            !linhaPerguntas.compoeCompleto
                                        ) &&
                                        //(
                                        //    !jsonIntegracao ||
                                        //    !jsonIntegracao.integracaoInclusaoSiteInstitucional ||
                                        //    !jsonIntegracao.integracaoInclusaoCaptacaoLeads
                                        //)
                                        !integracaoInstitucionalCaptacaoLeads &&
                                        !grupoPerguntaAnt && (
                                            <CardGridDividerElementos />
                                        )}

                                        <GridContainer>
                                            <GridItem12>
                                                <GridContainer>
                                                    {grupoPerguntaAnt
                                                        ?
                                                            <GridItem5xs12
                                                                className={"mt-5 font-medium text-labelPergunta"/*text-muted"*/}
                                                            >
                                                                {linhaPerguntas.descricao}
                                                            </GridItem5xs12>
                                                        :
                                                            linhaPerguntas.compoeCompleto
                                                                ?
                                                                    ''
                                                                :
                                                                    <GridItemDescricao
                                                                        className={"mt-4 mb-2 font-medium text-labelPergunta"/* text-muted"*/}
                                                                    >
                                                                        {linhaPerguntas.descricao}
                                                                    </GridItemDescricao>
                                                    }

                                                    <GridItem6xs12>
                                                        <GridContainer>
                                                            {
                                                                linhaPerguntas.type === "Valor" ?
                                                                    <GridItem3xs12>
                                                                        <TextValidatorValor
                                                                            name={`perguntas[${ind}].valor`}
                                                                            label={""}
                                                                            value={item.valor || ''}
                                                                            onChange={handleChange}
                                                                            onBlur={processaAlteracaoPerguntasValor(values, item,
                                                                                linhaFormList)
                                                                            }
                                                                        />
                                                                    </GridItem3xs12>
                                                                : linhaPerguntas.type === "ValorPerc" ?
                                                                    <>
                                                                        <GridItem3sm4xs10>
                                                                            <TextValidatorValor
                                                                                name={`perguntas[${ind}].valor`}
                                                                                label={LABEL.valor}
                                                                                value={item.valor || ''}
                                                                                onChange={handleChange}
                                                                                onBlur={processaAlteracaoPerguntasValor(values,
                                                                                    item, linhaFormList)
                                                                                }
                                                                            />
                                                                        </GridItem3sm4xs10>
                                                                        {dadosCompletosConjuge(values, true)
                                                                            ?
                                                                                <GridItem2sm3xs6>
                                                                                    <TextValidatorNumber
                                                                                        name={`perguntas[${ind}].perc`}
                                                                                        label={LABEL.perc + " " + tituloCliente(values)}
                                                                                        value={item.perc === 0 ? 0 : item.perc || ''}
                                                                                        onChange={handleChange}
                                                                                        numMin={NUMMIN.perc}
                                                                                        numMax={NUMMAX.perc}
                                                                                        onBlur={processaAlteracaoPerguntasValor(values,
                                                                                            item, linhaFormList)
                                                                                        }
                                                                                    />
                                                                                </GridItem2sm3xs6>
                                                                            :
                                                                                ''
                                                                        }
                                                                    </>
                                                                : linhaPerguntas.type === "ValorValor" ?
                                                                    <>
                                                                        <GridItem3sm4xs10>
                                                                            <TextValidatorValor
                                                                                name={`perguntas[${ind}].valor`}
                                                                                label={tituloCliente(values)}
                                                                                value={item.valor || ''}
                                                                                onChange={handleChange}
                                                                                onBlur={processaAlteracaoPerguntasValor(values,
                                                                                    item, linhaFormList)
                                                                                }
                                                                            />
                                                                        </GridItem3sm4xs10>
                                                                        {dadosCompletosConjuge(values, true)
                                                                            ?
                                                                                <GridItem3sm4xs10>
                                                                                    <TextValidatorValor
                                                                                        name={`perguntas[${ind}].valor2`}
                                                                                        label={tituloConjuge(values)}
                                                                                        value={item.valor2 || ''}
                                                                                        onChange={handleChange}
                                                                                        onBlur={processaAlteracaoPerguntasValor(values,
                                                                                            item, linhaFormList)
                                                                                        }
                                                                                    />
                                                                                </GridItem3sm4xs10>
                                                                            :
                                                                                ''
                                                                        }
                                                                    </>
                                                                : linhaPerguntas.type === "ValorAnos" ?
                                                                    <>
                                                                        <GridItem3sm4xs10>
                                                                            <TextValidatorValor
                                                                                name={`perguntas[${ind}].valor`}
                                                                                label={LABEL.valor}
                                                                                value={item.valor || ''}
                                                                                onChange={handleChange}
                                                                                onBlur={processaAlteracaoPerguntasValor(values,
                                                                                    item, linhaFormList)
                                                                                }
                                                                            />
                                                                        </GridItem3sm4xs10>
                                                                        <GridItem2sm3xs6>
                                                                            <TextValidatorNumber
                                                                                name={`perguntas[${ind}].anos`}
                                                                                label={LABELESPECIAL.anos}
                                                                                value={item.anos === 0 ? 0 : item.anos || ''}
                                                                                onChange={handleChange}
                                                                                numMin={NUMMIN.anos}
                                                                                numMax={NUMMAX.anos}
                                                                            />
                                                                        </GridItem2sm3xs6>
                                                                    </>
                                                                : linhaPerguntas.type === "Previdencia" ?
                                                                    <>
                                                                    </>
                                                                : linhaPerguntas.type === "Inteiro" ?
                                                                    <GridItem2sm3xs6>
                                                                        <TextValidatorNumber
                                                                            name={`perguntas[${ind}].inteiro`}
                                                                            label={""}
                                                                            value={item.inteiro === 0 ? 0 : item.inteiro || ''}
                                                                            onChange={handleChange}
                                                                            numMin={linhaPerguntas.numMin}
                                                                            numMax={linhaPerguntas.numMax}
                                                                        />
                                                                    </GridItem2sm3xs6>

                                                                : linhaPerguntas.type === "String" ?
                                                                    <GridItem8xs12>
                                                                        <TextValidatorText
                                                                            name={`perguntas[${ind}].string`}
                                                                            label={""}
                                                                            value={item.string || ''}
                                                                            onChange={handleChange}
                                                                            tamMax={linhaPerguntas.tamMax}
                                                                        />
                                                                    </GridItem8xs12>

                                                                : linhaPerguntas.type === "MultiLine" ?
                                                                    <GridItem12>
                                                                        <TextValidatorText
                                                                            name={`perguntas[${ind}].multiLine`}
                                                                            label={""}
                                                                            value={item.multiLine || ''}
                                                                            onChange={handleChange}
                                                                            tamMax={linhaPerguntas.tamMax}
                                                                            notToUpperCase={true}
                                                                        />
                                                                    </GridItem12>

                                                                : linhaPerguntas.type === "MultiList" ?
                                                                    <GridItem12>
                                                                        <FormFormMultiList
                                                                            values={values}
                                                                            handleChange={handleChange}
                                                                            linhaPerguntas={linhaPerguntas}
                                                                            indPergunta={ind}
                                                                        />
                                                                    </GridItem12>

                                                                :
                                                                    <GridItem6xs12>
                                                                        {
                                                                            linhaPerguntas.type === "SimNao" ?
                                                                                <SimNaoRadioGroup
                                                                                    name={`perguntas[${ind}].simNao`}
                                                                                    value={item.simNao || ''}
                                                                                    onChange={handleChange}
                                                                                />
                                                                            : linhaPerguntas.type === "SimNaoCelular" ?
                                                                                <>
                                                                                    <SimNaoRadioGroup
                                                                                        name={`perguntas[${ind}].simNao`}
                                                                                        value={item.simNao || ''}
                                                                                        onChange={handleChange}
                                                                                    />

                                                                                    {item.simNao === 'S' && (
                                                                                        <TextValidatorCelular
                                                                                            name={`perguntas[${ind}].celular`}
                                                                                            label={LABEL.celular}
                                                                                            value={item.celular || ''}
                                                                                            onChange={handleChange}
                                                                                        />
                                                                                    )}
                                                                                </>
                                                                            : linhaPerguntas.type === "Radio" ?
                                                                                <GridItemRadioList>
                                                                                    <ListRadioGroup
                                                                                        name={`perguntas[${ind}].radio`}
                                                                                        value={item.radio || ''}
                                                                                        onChange={handleChange}
                                                                                        list={linhaPerguntas.list}
                                                                                    />
                                                                                    {linhaPerguntas.idOutros &&
                                                                                    item.radio === linhaPerguntas.idOutros && (
                                                                                        <GridContainer>
                                                                                            <GridItem1/>
                                                                                            <GridItem10>
                                                                                                <TextValidatorText
                                                                                                    name={`perguntas[${ind}].radioOutros`}
                                                                                                    label={""}
                                                                                                    value={item.radioOutros || ''}
                                                                                                    onChange={handleChange}
                                                                                                    tamMax={linhaPerguntas.tamMaxOutros}
                                                                                                />
                                                                                            </GridItem10>
                                                                                        </GridContainer>
                                                                                    )}
                                                                                </GridItemRadioList>
                                                                            : linhaPerguntas.type === "List" ?
                                                                                <GridItemRadioList>
                                                                                    <TextFieldNumberSelect
                                                                                        name={`perguntas[${ind}].idList`}
                                                                                        label={""}
                                                                                        value={item.idList === 0 ? 0 : item.idList || ''}
                                                                                        onChange={handleChange}
                                                                                        list={linhaPerguntas.list}
                                                                                    />
                                                                                </GridItemRadioList>
                                                                            :
                                                                                ''
                                                                        }
                                                                    </GridItem6xs12>
                                                            }
                                                        </GridContainer>
                                                    </GridItem6xs12>
                                                </GridContainer>

                                                {linhaPerguntas.compoeCompleto && (

                                                    <CardGridEntradaDadosHeaderBody
                                                        title={
                                                            <GridContainer>
                                                                <GridItem6>
                                                                    {linhaPerguntas.descricao}
                                                                </GridItem6>
                                                                <GridItem6>
                                                                    {linhaFormTypeList.id &&
                                                                    values[linhaFormTypeList.stepsValor]
                                                                    [linhaFormTypeList.indexStepsValor]
                                                                        ?
                                                                            formataValor(values
                                                                                [linhaFormTypeList.stepsValor]
                                                                                [linhaFormTypeList
                                                                                .indexStepsValor], 2) 
                                                                        :
                                                                            ''
                                                                    }
                                                                </GridItem6>
                                                            </GridContainer>
                                                        }
                                                        component={
                                                            <IconButtonExpandMoreLess
                                                                name={`perguntas[${ind}].expanded`}
                                                                item={item}
                                                                lista={values.perguntas}
                                                                setFieldValue={setFieldValue}
                                                                onClick={() => {salvarAutomaticamente()}}
                                                                onClickAll={() => {salvarAutomaticamente()}}
                                                            />
                                                        }
                                                    >
                                                        {item.expanded && (
                                                            <>
                                                                {linhaPerguntas.type ===
                                                                HARDCODE.formTypeAposentadoriaExpectativaVidaClienteConjuge && (
                                                                    <AposentadoriaExpectativaVidaClienteAposentadoriaExpectativaVidaClienteConjuge
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        setFieldValue={setFieldValue}
                                                                    />
                                                                )}

                                                                {linhaPerguntas.type ===
                                                                HARDCODE.formTypeReceitaMensal && (
                                                                    <FormFormReceitaMensal
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        setFieldValue={setFieldValue}
                                                                        title={linhaPerguntas.descricao}
                                                                    />
                                                                )}

                                                                {linhaPerguntas.type ===
                                                                HARDCODE.formTypeDiaDia && (
                                                                    <FormFormDiaDia
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        setFieldValue={setFieldValue}
                                                                        linhaTipoLicenca={vars.linhaTipoLicenca}
                                                                        jsonConfiguracao={vars.jsonConfiguracao}
                                                                        title={linhaPerguntas.descricao}
                                                                    />
                                                                )}

                                                                {linhaPerguntas.type === HARDCODE.formTypeEducacao && (
                                                                    <FormFormEducacao
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        setFieldValue={setFieldValue}
                                                                        jsonConfiguracao={vars.jsonConfiguracao}
                                                                        title={linhaPerguntas.descricao}
                                                                    />
                                                                )}

                                                                {linhaPerguntas.type ===
                                                                HARDCODE.formTypeFinanciamento && (
                                                                    <FormFormFinanciamento
                                                                        variaveisGlobais={variaveisGlobais}
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        handleSubmit={handleSubmit}
                                                                        setFieldValue={setFieldValue}
                                                                        linhaTipoLicenca={vars.linhaTipoLicenca}
                                                                        title={linhaPerguntas.descricao}
                                                                    />
                                                                )}
                                                                
                                                                {linhaPerguntas.type ===
                                                                HARDCODE.formTypeProjetoVidaSonho && (
                                                                    <FormFormProjetoVidaSonho
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        setFieldValue={setFieldValue}
                                                                        linhaTipoLicenca={vars.linhaTipoLicenca}
                                                                        title={linhaPerguntas.descricao}
                                                                    />
                                                                )}

                                                                {linhaPerguntas.type ===
                                                                HARDCODE.formTypePatrimonioImobilizado && (
                                                                    <FormFormPatrimonioImobilizado
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        setFieldValue={setFieldValue}
                                                                        title={linhaPerguntas.descricao}
                                                                    />
                                                                )}
                                                                
                                                                {linhaPerguntas.type ===
                                                                HARDCODE.formTypeRecursosFinanceiros && (
                                                                    <FormFormRecursosFinanceiros
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        setFieldValue={setFieldValue}
                                                                        linhaTipoLicenca={vars.linhaTipoLicenca}
                                                                        //jsonConfiguracao={vars.jsonConfiguracao}
                                                                        title={linhaPerguntas.descricao}
                                                                    />
                                                                )}

                                                                {linhaPerguntas.type ===
                                                                HARDCODE.formTypeSolicitacaoArquivo && (
                                                                    <FormFormSolicitacaoArquivo
                                                                        variaveisGlobais={variaveisGlobais}
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        setFieldValue={setFieldValue}
                                                                        vars={vars}
                                                                        arquivoList={arquivoList}
                                                                        obterArquivoList={obterArquivoList}
                                                                        //linhaTipoLicenca={vars.linhaTipoLicenca}
                                                                        //jsonConfiguracao={vars.jsonConfiguracao}
                                                                        //title={linhaPerguntas.descricao}
                                                                    />
                                                                )}
                                                            </>
                                                        )}
                                                    </CardGridEntradaDadosHeaderBody>
                                                )}
                                            </GridItem12>
                                        </GridContainer>
                                    </CardGridDivBodyEntradaDados>
                                )
                                :
                                (
                                    ''
                                )
                            })}
                        </DivForm>
                    </DivForm>
                )}
            </FieldArray>
        </>      
    )
}



const FormFormPerguntas = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, vars/*linhaTipoLicenca,*/ /*idConfiguracao,*/ /*jsonConfiguracao*/,
        /*jsonUsuario, jsonUsuarioAdmin,*/ linhaFormList,
            completo, jsonIntegracao, arquivoList, obterArquivoList }) => {

    calculaTotaisReceitaMensal(values)
    calculaTotaisDiaDia(values, vars.jsonConfiguracao)
    calculaTotaisEducacao(values)
    calculaTotaisFinanciamento(values)
    calculaTotaisProjetoVidaSonho(values)
    calculaTotaisPatrimonioImobilizado(values)
    calculaTotaisRecursosFinanceiros(values)

    //const [pdf, setPdf] = useState(null)
    const [formularioList, setFormularioList] = useState(null)
    const [primInd, setPrimInd] = useState(null)

    /*
    const obterInstitucional = async () => {

        if (idConfiguracao) {

            const arquivoArquivoAcessoDTO =
                await getArquivoByGrupoArquivoTipoArquivoConteudo(variaveisGlobais,
                    ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
                        HARDCODE.idGrupoArquivoConfiguracao, HARDCODE.idTipoArquivoInstitucional, idConfiguracao, null, null)

            setPdf(arquivoArquivoAcessoDTO.conteudo)
        }
    }
        */

    useSingleton(() => {

        //obterInstitucional()

        calculaIdadesDataSimulacao(values, false)

        const formularioListAux = calculaConfiguracaoPerguntas(variaveisGlobais, values,
            linhaFormList, vars.jsonUsuario, vars.jsonUsuarioAdmin, jsonIntegracao)
        
        setFormularioList(formularioListAux)

        processaRegistrosDefaultIniciaisPerguntas(values, linhaFormList, formularioListAux, values.formulario, completo, setPrimInd)

        processaRegistrosDefaultIniciaisEducacao(values, vars.jsonConfiguracao)
        calculaEducacaoFilhaoEnteadaoBaseOutraosFilhaosEnteadaos(values)

        processaValoresDefaultIniciaisCenariosTaxas(values)
        processaValoresDefaultIniciaisClienteConjuge(values)

        processaCenariosDefaultJsonUsuario(values, vars.jsonUsuario, vars.jsonUsuarioAdmin)
    })

    let grupoPerguntaAnt = ''

    return (
        formularioList
            ?
                jsonIntegracao && (jsonIntegracao.integracaoInclusaoSiteInstitucional || jsonIntegracao.integracaoInclusaoCaptacaoLeads)
                    ?
                        <FormFormPerguntasAux
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            handleSubmitAutomatico={handleSubmitAutomatico}
                            vars={vars}
                            //linhaTipoLicenca={linhaTipoLicenca}
                            //jsonConfiguracao={vars.jsonConfiguracao}
                            linhaFormList={linhaFormList}
                            completo={completo}
                            jsonIntegracao={jsonIntegracao}
                            arquivoList={arquivoList}
                            obterArquivoList={obterArquivoList}
                            formularioList={formularioList}
                            setPrimInd={setPrimInd}
                            primInd={primInd}
                            //pdf={pdf}
                            grupoPerguntaAnt={grupoPerguntaAnt}
                        />
                    :
                        <GridContainer
                            className="justify-center"
                        >
                            <GridItem12>
                                <CardGridEntradaDados>
                                    <CardGridDivBodyEntradaDados>
                                        
                                        <ValidatorFormPadrao
                                            onSubmit={handleSubmit}
                                            onError={
                                                () => null
                                            }
                                        >
                                            <FormFormPerguntasAux
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                handleChange={handleChange}
                                                handleSubmit={handleSubmit}
                                                setFieldValue={setFieldValue}
                                                handleSubmitAutomatico={handleSubmitAutomatico}
                                                vars={vars}
                                                //linhaTipoLicenca={linhaTipoLicenca}
                                                //jsonConfiguracao={vars.jsonConfiguracao}
                                                linhaFormList={linhaFormList}
                                                completo={completo}
                                                jsonIntegracao={jsonIntegracao}
                                                arquivoList={arquivoList}
                                                obterArquivoList={obterArquivoList}
                                                formularioList={formularioList}
                                                setPrimInd={setPrimInd}
                                                primInd={primInd}
                                                //pdf={pdf}
                                                grupoPerguntaAnt={grupoPerguntaAnt}
                                            />
                                        </ValidatorFormPadrao>
                                    </CardGridDivBodyEntradaDados>
                                </CardGridEntradaDados>
                            </GridItem12>
                        </GridContainer>
            :
                ''
    )
}

export default FormFormPerguntas